import React, { createContext, useContext, useState, useMemo, useCallback } from "react";

/**
 * Due-filter and due-sort state shared between the active Stage page and the
 * Layout's pipeline navigation — so per-stage count badges can update live
 * as the user narrows the current stage's Due column filter.
 */
const DueFilterContext = createContext({
  dueFilter: null,
  dueSort: null,
  activeStage: null,
  setDueFilter: () => {},
  setDueSort: () => {},
  setActiveStage: () => {},
});

export function DueFilterProvider({ children }) {
  const [dueFilter, setDueFilterRaw] = useState(null);
  const [dueSort, setDueSort] = useState(null);
  const [activeStage, setActiveStage] = useState(null);
  // Reset filter when navigating to a different stage (each stage page owns its own filter context)
  const setDueFilter = useCallback((v) => setDueFilterRaw(v), []);
  const value = useMemo(() => ({
    dueFilter, dueSort, activeStage,
    setDueFilter, setDueSort, setActiveStage,
  }), [dueFilter, dueSort, activeStage, setDueFilter]);
  return <DueFilterContext.Provider value={value}>{children}</DueFilterContext.Provider>;
}

export function useDueFilter() {
  return useContext(DueFilterContext);
}
